/**
 * @fileoverview Quoted-reply splitting for mail bodies (MOR-529).
 *
 * Email clients append the prior conversation below a reply ("On ... wrote:"
 * followed by `>`-prefixed lines). Rendering that verbatim buries the actual
 * message, so readers split it off and collapse it behind a toggle — the
 * Gmail "show quoted text" pattern.
 */

const QUOTE_MARKERS = [
  /^On .{5,300} wrote:\s*$/,
  /^-{5,} ?Forwarded message ?-{5,}$/i,
  /^-{5,} ?Original Message ?-{5,}$/i,
  /^_{10,}\s*$/,
];

/**
 * Splits a plain-text body into the fresh message and the quoted history.
 * `quoted` is null when nothing quote-like is found.
 */
export function splitQuotedText(body: string): {
  main: string;
  quoted: string | null;
} {
  const lines = body.split("\n");
  const cut = lines.findIndex(
    (line) =>
      line.startsWith(">") || QUOTE_MARKERS.some((re) => re.test(line.trim())),
  );
  // Never split at the very top — a body that IS entirely a quote should
  // still render (otherwise the message looks empty).
  if (cut <= 0) return { main: body, quoted: null };
  const main = lines.slice(0, cut).join("\n").trimEnd();
  const quoted = lines.slice(cut).join("\n").trim();
  if (main.length === 0 || quoted.length === 0) {
    return { main: body, quoted: null };
  }
  return { main, quoted };
}
